var $3a9a3d180c3145c0$exports = {};
$3a9a3d180c3145c0$exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};


export {$3a9a3d180c3145c0$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
